import { _,$,Backbone } from '../../../../vendor'
import { Backform,Biscuit,Notification } from '../../../utils'
import InboomaBaseModel from '../../../models/InboomaBaseModel'
import InboomaBaseView from '../../InboomaBaseView'

const PayoutModel = InboomaBaseModel.extend({

    urlRoot : '/connects/payoutStripeAccount',
    defaults : {
        client_id : null,
        amount : 0
    },
    _rbac : {}

})

export default InboomaBaseView.extend({

    el : '.inb-payout-form-modal',
    template : _.noop,

    ui : {
      errorMessageField : '.off-canvas__form-error',
    },

    initialize () {

      this.model = new PayoutModel({
          client_id : Number(Biscuit.get('user.client_id'))
      })

      this.transactions = this.options.transactions;

      this.render()

    },

    onRender () {

        this.getUI('errorMessageField').addClass('hide');
        
        const that = this,
              fields = [
                {
                    name : "amount",
                    label : this.t('amount',null,'capital'),
                    required : true,
                    control: "input",
                    type : "number",
                    helpMessage : this.t('payout_amount_help'),
                    size : {
                      "small" : "12"
                    },
                    extraAttributes : ['min="1"', 'max="50"']
                },{
                    label : this.t('confirm_payout'),
                    control : "button",
                    extraClasses : ['expanded button-submit']
                }
            ],

            payoutModal = new Foundation.Reveal(this.$el),

            form = new Backform.Form({

                  el : that.$el.find('.inb-payout-form__content'),
                  model : that.model,
                  fields : fields,

                  events : {
                    "submit" () {
                      return false;
                    },

                    "click .button-submit" (ev) {
                    
                      ev.preventDefault();
                      that.$el.find('form .is-invalid-input')
                          .removeClass('is-invalid-input');

                      $(that.$el.find('form')).foundation('validateForm');

                      // Float'ify
                      that.model.set('amount', Number(that.model.get('amount')))

                      if (that.model.get('amount') != '' && that.model.get('amount') != NaN && !that.$el.find('form .is-invalid-input').length) {

                        that.model.save(null,{
                          success : (model, response) => {

                            console.log('success - model', model, response);

                            if (response.success) {
                              
                              // Update transactions collection
                              that.transactions._pagination.current_page = 0;
                              that.transactions.fetch();

                              payoutModal.close();

                              new Notification({
                                message : that.t('payout_success'),
                                duration : 5000,
                                type : 'success',
                                closeable : true,
                                icon : 'fi fi-marker'
                              }); 

                            } else {

                              switch (response.error_code) {
                                case '999' :

                                /*new Notification({
                                  message : that.t('payout_error_999'),
                                  duration : 5000,
                                  type : 'success',
                                  closeable : true,
                                  icon : 'fi fi-marker'
                                });*/
                                that.getUI('errorMessageField')
                                    .removeClass('hide')
                                    .html(that.t('payout_error_999'))
                                    .fadeIn('fast');

                                break;
                              }

                            }

                          }, error: (model, response, options) => {

                            console.log('error', model);
                            
                            that.getUI('errorMessageField')
                                .removeClass('hide')
                                .html(that.t('request_error'))
                                .fadeIn('fast');
                          }
                        });

                    } else {

                      that.getUI('errorMessageField')
                          .removeClass('hide')
                          .html(that.t('form_validation_error'))
                          .fadeIn('fast');

                    }

                  }
                }
            }).render();

            new Foundation.Abide(that.$el.find('form'), { liveValidate:true });

            payoutModal.open();

            $(document).on('closed.zf.reveal', () => {
              // @TODO Same bug as his time in offCanvasBehavior
              Backbone.history.navigate('my-inbooma/finances');
              that.remove();
              that.destroy();
              that.unbind();
              delete that.model;
              $(document).off('closed.zf.reveal');
            });

    }
});